// Constantes compartilhadas entre a lista e o modal de visualização de templates.

export const STATUS_BADGES = {
  APPROVED:  { label: "Aprovado",             cls: "bg-emerald-950 text-emerald-300 border-emerald-800" },
  PENDING:   { label: "Aguardando aprovação", cls: "bg-amber-950 text-amber-300 border-amber-800" },
  REJECTED:  { label: "Rejeitado",            cls: "bg-red-950 text-red-300 border-red-800" },
  PAUSED:    { label: "Pausado",              cls: "bg-orange-950 text-orange-300 border-orange-800" },
  DISABLED:  { label: "Desativado",           cls: "bg-surface-1 text-ink-3 border-white/[0.08]" },
  IN_APPEAL: { label: "Em recurso",           cls: "bg-blue-950 text-blue-300 border-blue-800" },
};

export const CATEGORY_LABEL = {
  MARKETING: "Marketing",
  UTILITY: "Utilitário",
  AUTHENTICATION: "Auth",
};

export const HEADER_FORMAT_LABEL = {
  TEXT: "Texto",
  IMAGE: "Imagem",
  VIDEO: "Vídeo",
  DOCUMENT: "Documento",
  LOCATION: "Localização",
};

export function findComponent(components, type) {
  return Array.isArray(components) ? components.find((c) => c?.type === type) : null;
}

/** Texto do body do template (com {{n}} intactos) — usado no snippet da lista e no modal. */
export function getBodyText(components) {
  return findComponent(components, "BODY")?.text || "";
}
